export default {
  getUser: (state) => state,
}
